export default __webpack_public_path__ + "static/media/RESET_BLOCKS_ICON.48386f5e.svg";